export const GOOGLE_AUTHENTICATOR = 'GOOGLE_AUTHENTICATOR';
export const SMS = 'SMS';
export const SECURITY_PHONE_NUMBER = 'SECURITY_PHONE_NUMBER';